import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';

export default function useGetProductBundle(params) {
    return useQuery({
        queryKey: ['product-bundle', params],
        queryFn: async () => {
            const { data } = await authAxios.get('/api/v2/sellout/product-mapping', {
                params,
            });
            return data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        keepPreviousData: true,
    });
}

export function useGetProductSatuan(params) {
    return useQuery({
        queryKey: ['product-satuan', params],
        queryFn: async () => {
            const { data } = await authAxios.get('/api/v2/sellout/product-mapping', {
                params,
            });
            return data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        keepPreviousData: true,
    });
}
